// A label and its value under a history cell's first line: `Ora: 11:54`,
// `Motiv: Import CUATM`.
//
// The wireframe draws every one of these with the same component
// (`components/MetadataLine.tsx`) and the same two weights of grey: the label in
// `--text-tertiary`, the value in `--text-secondary`, 12/16, four pixels apart,
// the colon written by the markup rather than by the copy. The register had them
// as one interpolated string in one colour at 11px, so the label and the fact
// read as equally important — and the same pair one column over
// (`.simsm-history__entity-fact`) already followed the wireframe.
//
// The colon lives here, which is also why the copy holds the bare label: a
// translation that carried `Motiv: {source}` could not be split into two
// elements without parsing it back apart.
export function HistoryMeta({ label, value }: { label: string; value: string }): JSX.Element {
  return (
    <dl className="simsm-history__meta">
      <dt>{label}:</dt>
      <dd>{value}</dd>
    </dl>
  );
}
